import Swiper, {Navigation, Pagination} from "swiper";

Swiper.use([Navigation, Pagination])
export function initMainPhotoSlider(){

    let swiper = new Swiper('#main_photo_slider', {
        speed: 900,
        preloadImages: false,
        spaceBetween: 32,
        allowTouchMove: true,
        slidesPerView: 'auto',
        pagination:{
            el: '.main-photo-slider-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            nextEl: '.main-photo-swiper-next',
            prevEl: '.main-photo-swiper-prev',
        },
        breakpoints: {
            768: {
                spaceBetween: 32,
            }
        }
    });
}